// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.bTLC3nD6k68Z872QWIce {
  display: flex;
  padding: 20px;
  height: 100%;
  justify-content: center;
  overflow: auto;
}
.lWCveU7mJTdVvYgvB81Q {
  text-align: center;
  margin-bottom: 50px;
}
.pv_rJyfkbcP2ZnsKxbQc {
  width: 600px;
}
`, "",{"version":3,"sources":["webpack://./src/pages/Organizations/Create/index.module.less"],"names":[],"mappings":"AACA;EACE,aAAA;EACA,aAAA;EACA,YAAA;EACA,uBAAA;EACA,cAAA;AAAF;AAGA;EACE,kBAAA;EACA,mBAAA;AADF;AAIA;EACE,YAAA;AAFF","sourcesContent":["\n.container {\n  display: flex;\n  padding: 20px;\n  height: 100%;\n  justify-content: center;\n  overflow: auto;\n}\n\n.titleContent {\n  text-align: center;\n  margin-bottom: 50px;\n}\n\n.form {\n  width: 600px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `bTLC3nD6k68Z872QWIce`,
	"titleContent": `lWCveU7mJTdVvYgvB81Q`,
	"form": `pv_rJyfkbcP2ZnsKxbQc`
};
export default ___CSS_LOADER_EXPORT___;
